import { render, staticRenderFns } from "./rk-page.vue?vue&type=template&id=4d2f8066&scoped=true&"
import script from "./rk-page.vue?vue&type=script&lang=js&"
export * from "./rk-page.vue?vue&type=script&lang=js&"
import style0 from "./rk-page.vue?vue&type=style&index=0&id=4d2f8066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2f8066",
  null
  
)

export default component.exports